import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Download } from "lucide-react";

export default function AdminWaitlistToolbar({ query, onQueryChange, onExport }) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <Input
        data-testid="admin-search"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Search email or idea…"
        className="max-w-xs bg-white/5 border-white/20 text-white placeholder:text-white/40 rounded-full h-10"
      />
      <Button
        data-testid="admin-export-csv"
        onClick={onExport}
        className="ml-auto rounded-full bg-neon-cyan text-slate-900 font-bold hover:bg-neon-cyan/90 neon-glow-cyan"
      >
        <Download className="w-4 h-4 mr-1" /> Export CSV
      </Button>
    </div>
  );
}
